/**
 * Module to move by the scroll using arrows.
 *
 * Need to add the following attributes:
 * data-scroll: to the element scrolled
 * data-arrow-right: to the arrow right button
 * data-arrow-left: to the arrow left button
 * data-move-arrow: to the arrows with the number of pixels to be move.
 * data-element-scrolled: all elements that are inside the container
 * need to have the property to get the first and last element in the collection.
 */
(function arrowHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};
  const isTouchScreen = Object.prototype.hasOwnProperty.call(global, 'ontouchstart');
  const eventTrigger = isTouchScreen ? 'touchend' : 'click';

  class ArrowHandler {
    constructor(parameters) {
      if (!parameters.container) {
        return;
      }
      this.container = null;
      this.arrowRight = null;
      this.arrowLeft = null;
      this.firstCollection = null;
      this.lastCollection = null;
      this.scrollElement = null;
      this.move = 0;
      this.limitRight = 0;
      this.limitLeft = 0;
      this.arrowsReference =
        parameters.arrowReferenceSelector ? parameters.arrowReferenceSelector : '';
      this.collectionsReference =
        parameters.collectionsReferenceSelector ? parameters.collectionsReferenceSelector : '';
      this.container = parameters.container;
      this.arrowRight = this.container.querySelector(`${this.arrowsReference}[data-arrow-right]`);
      this.arrowLeft = this.container.querySelector(`${this.arrowsReference}[data-arrow-left]`);
      this.scrollElement = this.container.querySelector('[data-scroll]') || this.container;
      this.firstCollection =
        this.container.querySelector(`${this.collectionsReference}[data-element-scrolled]`);
      this.lastCollection =
        this.container.querySelector(`${this.collectionsReference}[data-element-scrolled]:last-child`);
      if (!this.arrowRight || !this.arrowLeft || !this.scrollElement) {
        return;
      }

      this.bindedCalculateMoveCallback = this.bindedCalculateMove.bind(this);
      this.bindedOnChangeCallback = this.onChange.bind(this);

      this.container.addEventListener(eventTrigger, this.bindedCalculateMoveCallback);
      this.container.addEventListener('recalculateLimits', this.bindedOnChangeCallback);
      global.addEventListener('orientationchange', this.bindedOnChangeCallback);
      this.getLimits();
      this.observeVisibility();
    }

    bindedCalculateMove(event) {
      requestAnimationFrame(this.calculateMove.bind(this, event));
    }

    /** Used to show the arrows after a container is set as visible after being hidden */
    observeVisibility() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.showArrows();
          }
        });
      });

      observer.observe(this.container);
    }

    changeLimits() {
      this.limitLeft = Math.floor(this.container.getBoundingClientRect().left);
      this.limitRight = Math.floor(this.container.getBoundingClientRect().right);
      this.showArrows();
    }

    getLimits() {
      requestAnimationFrame(this.changeLimits.bind(this));
    }

    onChange() {
      requestAnimationFrame(this.getLimits.bind(this));
    }

    showArrows() {
      requestAnimationFrame(() => {
        if (Math.floor(this.firstCollection.getBoundingClientRect().left) < this.limitLeft) {
          this.arrowLeft.style.display = 'block';
          this.container.classList.add('tab-shadow--left');
        } else {
          this.arrowLeft.style.display = 'none';
          this.container.classList.remove('tab-shadow--left');
        }

        if (Math.floor(this.lastCollection.getBoundingClientRect().right) > this.limitRight) {
          this.arrowRight.style.display = 'block';
          this.container.classList.add('tab-shadow--right');
        } else {
          this.arrowRight.style.display = 'none';
          this.container.classList.remove('tab-shadow--right');
        }
      });
    }

    calculateMove(event) {
      this.limitLeft = Math.floor(this.container.getBoundingClientRect().left);
      this.limitRight = Math.floor(this.container.getBoundingClientRect().right);
      const element = event && event.target.closest(`${this.arrowsReference}[data-move-arrow]`);
      if (element) {
        this.move = +element.dataset.moveArrow;
        this.scrollElement.scrollBy(this.move, 0);
        const self = this;
        requestAnimationFrame(() => {
          self.showArrows(self);
          const scrolledCarousels = this.container.querySelectorAll('[data-scroll]');

          scrolledCarousels.forEach((scrolledCarousel) => {
            if (scrolledCarousel && scrolledCarousel.parentElement) {
              scrolledCarousel.parentElement.dispatchEvent(new Event('recalculateLimits'));
            }
          });
        });
      } else {
        requestAnimationFrame(() => {
          this.showArrows(this);
        });
      }
    }

    dispose() {
      this.container.removeEventListener(eventTrigger, this.bindedCalculateMoveCallback);
      this.container.removeEventListener('recalculateLimits', this.bindedOnChangeCallback);
      global.removeEventListener('orientationchange', this.bindedOnChangeCallback);
    }
  }

  global.NewHomeSource.Modules.ArrowHandler = ArrowHandler;
}(window));
